import React from 'react';
import Typography, { ITypography } from './BaseTypography';

type TypographyVariant = Omit<ITypography, 'variant'>;

export const Title: React.FunctionComponent<TypographyVariant> = (props) =>
    <Typography variant="title" {...props}/>;
export const SubTitle: React.FunctionComponent<TypographyVariant> = (props) =>
    <Typography variant="subtitle" {...props}/>;
